import React from 'react'
import { Button, Modal, Table, Tag, message } from "antd";

const VersionControl = (
  { contract, pendingEmails, columns,
    compareMode,
    setCompareMode,
    selectedPrev,
    setSelectedPrev,
    selectedCurr,
    setSelectedCurr,
    isComparing,
    setIsComparing,
    handleChangeView,
    handleEsignStatus,
    esignDetailModalOpen,
    setEsignDetailModalOpen,
    signuluResponse,
    handleSendReminder,
    isReminderLoading,
    handleEsignDocDownload,
    isLoading,
    esignColumns, }) => {
  return (
    <div>
      <div className=" text-black py-3 px-2 h-[60px] flex items-center justify-between mt-2">
        <h1 className="font-semibold text-[15px] dark:text-white">
          Version Control
        </h1>
        <div className="flex items-center justify-end gap-2">
          {contract && contract?.contract_history.length > 0 && <div className="items-center flex flex-col justify-center">
            <Button
              type={"default"
              }
              danger={compareMode && (!selectedPrev || !selectedCurr)}
              loading={isComparing} // 🔥 new state for comparing feedback
              className={`rounded-[10px] border text-purple my-3 border-[#d8bfd8] transition-colors duration-300 ${compareMode ? "h-[30px] my-1" : "h-[47.2px]"
                }`}
              onClick={async () => {

                if (!compareMode) {
                  setCompareMode(true);
                  setSelectedPrev(null);
                  setSelectedCurr(null);
                  message.info("Compare Mode Enabled. Select two DOCX files to compare.");
                  return;
                }
                if (compareMode && (!selectedPrev || !selectedCurr)) {
                  setCompareMode(false);
                  setSelectedPrev(null);
                  setSelectedCurr(null);
                  message.info("Compare Mode Disabled.");
                  return;
                }

                if (compareMode && selectedPrev && selectedCurr) {
                  setIsComparing(true);
                  message.loading({
                    content: "Files are comparing...",
                    key: "compareStatus",
                    duration: 0,
                  });

                  try {
                    await handleChangeView(selectedPrev, selectedCurr);
                    message.success({
                      content: "Comparison complete!",
                      key: "compareStatus",
                    });
                  } catch (err) {
                    message.error({
                      content: "Error comparing files!",
                      key: "compareStatus",
                    });
                  } finally {
                    setIsComparing(false);
                    setCompareMode(false);
                    setSelectedPrev(null);
                    setSelectedCurr(null);
                  }
                }
              }}
            >
              {compareMode
                ? selectedPrev && selectedCurr
                  ? "Compare Now"
                  : "Disable Compare Mode"
                : "Enable Compare Mode"}
            </Button>
            {compareMode && (
              <div style={{ marginBottom: 10 }}>
                <Tag color="blue" size="small">
                  {selectedCurr ? "✅ Curr File" : "🟠 Select Curr File"}
                </Tag>
                <Tag color="blue" size="small">
                  {selectedPrev ? "✅ Prev File" : "🟠 Select Prev File"}
                </Tag>
              </div>
            )}
          </div>}
          {contract.esign_status !== "draft" && (
            <Button
              onClick={handleEsignStatus}
              type="submit"
              className={`rounded-[10px] border text-purple my-3 border-[#d8bfd8] transition-colors duration-300 h-[47.2px]`}
            // className={`h-12 w-[15rem]  rounded-[10px] border border-[#d8bfd8] transition-colors duration-300 mt-8 -mr-2 mb-10 !text-purple !hover:text-[#800080] !bg-white`}
            >
              View E-sign Status
            </Button>
          )}
        </div>

      </div>

      <Modal
        title="E-sign Status"
        centered
        open={esignDetailModalOpen}
        closable={false}
        maskClosable
        width={1000}
        footer={
          [
            <Button
              key="reminder"
              type="primary"
              loading={isReminderLoading}
              onClick={handleSendReminder}
              disabled={!pendingEmails || pendingEmails.length === 0}
            >
              Send Reminder
            </Button>,
            <Button
              key="close"
              type="default"
              onClick={() => setEsignDetailModalOpen(false)}
            >
              Close
            </Button>,
          ]
        }
      >
        <>
          <div className="text-sm font-semibold my-2">
            Signature Initiated By-
            <span className="font-medium mx-2">
              {signuluResponse.senderName}
            </span>
          </div>
          <div className="text-sm font-semibold my-2">
            Comments
            <span className="font-medium mx-2">
              {signuluResponse.addComments
                ? signuluResponse?.addComments.map(
                  (comment, index) => {
                    return (
                      <span key={index}>
                        {index !== signuluResponse.length() - 1
                          ? `${comment},`
                          : `${comment}`}
                      </span>
                    );
                  }
                )
                : "No Comments"}
            </span>
          </div>
          <div className="text-sm font-semibold my-2">
            Expiration Date-
            <span className="font-medium mx-2">
              {signuluResponse?.expirationDate}
            </span>
          </div>
          <div className="text-sm font-semibold my-2">
            E-sign Status-
            <span className="font-semibold mx-2 mt-4">
              {signuluResponse?.statusCode?.toLowerCase() ===
                "approved" ? (
                <span className="bg-[#479D491A] text-[#479D49] px-2 py-2">
                  {signuluResponse.statusCode}
                </span>
              ) : signuluResponse?.statusCode?.toLowerCase() ===
                "rejected" ? (
                <span className="text-[#BA3928] bg-[#BA39281A] px-2 py-2">
                  {signuluResponse.statusCode}
                </span>
              ) : (
                <span className="text-[#F7CB73] bg-[#F7CB731A] px-2 py-2 ">
                  {signuluResponse.statusCode}
                </span>
              )}
            </span>
          </div>
          <div className="">
            <div className="text-sm font-semibold flex justify-between items-center h-10">
              <span>Recipients Details</span>
              {signuluResponse?.statusCode?.toLowerCase() !==
                "pending" && (
                  <Button
                    // isLoading
                    loading={isLoading} // Show loading spinner
                    disabled={isLoading}
                    onClick={handleEsignDocDownload}
                    type="submit"
                    className="flex items-center rounded-full border-2 border-success px-6 pb-[6px] pt-2 bg-green-500 text-xs font-medium uppercase leading-normal text-black transition duration-150 ease-in-out hover:border-success-600 hover:bg-neutral-500 hover:bg-opacity-10 hover:text-success-600 focus:border-success-600 focus:text-black focus:outline-none focus:ring-0 active:border-success-700 active:text-black-700 dark:hover:bg-neutral-100 dark:hover:bg-opacity-10 my-0"
                  >
                    Download Signed Document
                  </Button>
                )}
            </div>
            <Table
              dataSource={signuluResponse?.recepients}
              columns={esignColumns}
              pagination={false}
              scroll={{ x: "max-content" }}
              bordered
              className="mb-4 text-[12px] [&_.ant-table-cell]:p-1 [&_.ant-table-cell]:text-[12px]"
            />
          </div>
        </>
      </Modal>
      <Table
        dataSource={
          contract?.contract_history?.map((item, index) => ({
            ...item,
            key: item.id || item._id || index,
          }))
        }
        columns={columns}
        pagination={true}
        scroll={{ x: "max-content" }}
        bordered
        size="small"
        className="mt-1
        [&_.ant-table-cell]:!p-[3px] 
        [&_.ant-table-cell]:!text-[11px] 
        [&_.ant-table-thead_.ant-table-cell]:!text-[12px] 
        [&_.ant-table-thead_.ant-table-cell]:!p-[4px]"
      />
    </div>
  )
}

export default VersionControl;




